import { createFileRoute, Outlet, redirect } from "@tanstack/react-router";

import { WelcomeStep } from "core/models/welcome";
import { query } from "features/start/data";


export const Route = createFileRoute("/_private")({
	component: () => <Outlet />,
	beforeLoad: async ({ context }) => {
		if (!context.auth0?.isAuthenticated) throw redirect({ to: "/auth" });
		const { queryClient, auth0 } = context;
		await queryClient.ensureQueryData(query.auth0(auth0!));
	},
	loader: async ({ context, location }) => {
		const { queryClient } = context;
		const status = await queryClient.ensureQueryData(query.status);

		const onboarded = status.partners.some(p => p.step === WelcomeStep.Done);
		if (!onboarded) {
			const partner = status.partners.find(p => p.step) || status.partners[0];
			if (partner && !location.pathname.startsWith("/welcome")) {
				throw redirect({
					to: "/welcome/$partnerId",
					params: { partnerId: partner.id.toString() }
				});
			}
		}
	}
});